import { gql, useQuery } from '@apollo/client';

const GET_INTERESTS_QUERY = gql`
	query getInterests {
		getInterests{
			id
			text
			icon_name
		}
	}
`;
{
  /*Retorna un array de objetos con los objetivos de un usuario, incluyendo el id, el icono, el texto y el tipo*/
}
export default () => useQuery(GET_INTERESTS_QUERY);
